module.exports = __webpack_public_path__ + "img/lock.5a7ec40d.svg";